<template>
  <div class="bg bg8">
    <div class="class--con">
      <class-but @forward="forward"/>
    </div>
  </div>
</template>

<script>
import ClassBut from "@/views/conference/ConferenceItem/classBut.vue";


export default {
  name: "tenPage",
  components: {ClassBut},
  data() {
    return {

    }
  },
  methods: {
    forward() {
      this.$router.push({
        name: 'PageEleventh',
        query: this.$route.query,
      })
    },
  }
}
</script>

<style lang="less" scoped>
@import "reportClass.less";
</style>
